import { createContext, useReducer } from "react";

import { useMediaQuery } from 'react-responsive'
// import { useHistory } from "react-router-dom"

// import reducer and initialState
import {modalsReducer, modalsInitialState} from "./context/reducer/modalsReducer.jsx"
import {cartReducer, cartInitialState} from "./context/reducer/cartReducer.jsx"
import {authReducer, authInitialState} from "./context/reducer/authReducer.jsx"
import {orderReducer, orderInitialState} from "./context/reducer/orderReducer.jsx"

// import modules
import Router from "./routers/Router.jsx";

// create context to share state between components
export const ContextProvider = createContext();

function App() {

  const [modalsState, modalsDispatch] = useReducer(modalsReducer, modalsInitialState)  // useReducer hook to handle states
  const [cartState, cartDispatch] = useReducer(cartReducer, cartInitialState)  // useReducer hook to handle states
  const [authState, authDispatch] = useReducer(authReducer, authInitialState)  // useReducer hook to handle states
  const [orderState, orderDispatch] = useReducer(orderReducer, orderInitialState)  // useReducer hook to handle states

  const isMobile = useMediaQuery({ query: '(max-width: 375px)' })
  const isTablet = useMediaQuery({ query: '(max-width: 768px)' })

  return (
    <>
      <ContextProvider.Provider value={{ orderState, orderDispatch, modalsState, modalsDispatch, cartState, cartDispatch, isMobile,isTablet, authState, authDispatch }}>
        <Router />
      </ContextProvider.Provider>
    </>
  );
}

export default App;